<template>
	<v-footer id="brainlab-global-footer" class="global-footer">
		<div class="global-footer-content-container">
			<div class="global-footer-social-contact">
				<ul class="list-social list-unstyled list-inline">
					<li class="list-inline-item">
						<a target="_blank" href="https://www.linkedin.com/company/brainlab/" aria-label="LinkedIn">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								id="icon-sm-linkedin-footer"
								class="a-icon a-icon--social-media-list"
								viewBox="0 0 24 24">
								<path
									d="M21 21h-4v-6.75c0-1.06-1.19-1.94-2.25-1.94S13 13.19 13 14.25V21H9V9h4v2c.66-1.07 2.36-1.76 3.5-1.76 2.5 0 4.5 2.04 4.5 4.51V21M7 21H3V9h4v12M5 3a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2z" />
							</svg>
							<span class="sr-only">LinkedIn</span>
						</a>
					</li>
					<li class="list-inline-item">
						<a target="_blank" href="https://www.facebook.com/brainlabcorporate" aria-label="Facebook">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								id="icon-sm-facebook-footer"
								class="a-icon a-icon--social-media-list"
								viewBox="0 0 24 24">
								<path d="M17 2v4h-2c-.69 0-1 .81-1 1.5V10h3v4h-3v8h-4v-8H7v-4h3V6a4 4 0 0 1 4-4h3z" />
							</svg>
							<span class="sr-only">Facebook</span>
						</a>
					</li>
					<li class="list-inline-item">
						<a target="_blank" href="https://www.youtube.com/user/BrainlabCorporate" aria-label="Youtube">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								id="icon-sm-youtube-footer"
								class="a-icon a-icon--social-media-list"
								viewBox="0 0 24 24">
								<path
									d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83-.25.9-.83 1.48-1.73 1.73-.47.13-1.33.22-2.65.28-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44-.9-.25-1.48-.83-1.73-1.73-.13-.47-.22-1.1-.28-1.9-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83.25-.9.83-1.48 1.73-1.73.47-.13 1.33-.22 2.65-.28 1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44.9.25 1.48.83 1.73 1.73z" />
							</svg>
							<span class="sr-only">Youtube</span>
						</a>
					</li>
					<li class="list-inline-item">
						<a target="_blank" href="https://www.instagram.com/brainlabcorporate/" aria-label="Instagram">
							<svg
								id="icon-sm-instagram-footer"
								class="a-icon a-icon--social-media-list"
								viewBox="0 0 24 24"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M12 3.8c2.7 0 3 0 4 .1 1 0 1.5.2 1.9.3.4.2.8.4 1.1.8.3.3.6.7.7 1.1.2.4.4.9.4 1.9 0 1.1.1 1.4.1 4s0 3-.1 4c0 1-.2 1.5-.3 1.9-.3.9-1 1.6-1.9 1.9-.4.1-.9.3-1.9.3-1.1 0-1.4.1-4 .1s-3 0-4-.1c-1 0-1.5-.2-1.9-.3-.4-.2-.8-.4-1.1-.8-.3-.3-.6-.7-.7-1.1-.2-.4-.4-.9-.4-1.9 0-1.1-.1-1.4-.1-4s0-3 .1-4c0-1 .2-1.5.3-1.9.2-.4.4-.8.8-1.1.3-.3.7-.6 1.1-.7.4-.2.9-.4 1.9-.4 1-.1 1.3-.1 4-.1M12 2c-2.7 0-3.1 0-4.1.1-1.1 0-1.8.2-2.4.5-.7.2-1.3.6-1.8 1.1-.5.5-.9 1.1-1.2 1.7-.2.7-.4 1.4-.4 2.5C2 8.9 2 9.3 2 12s0 3.1.1 4.1c0 1.1.2 1.8.5 2.4.3.7.6 1.3 1.2 1.8.5.5 1.1.9 1.8 1.2.6.2 1.4.4 2.4.5h4c2.7 0 3.1 0 4.1-.1 1.1 0 1.8-.2 2.4-.5 1.3-.5 2.4-1.6 2.9-2.9.2-.6.4-1.4.5-2.4 0-1.1.1-1.4.1-4.1s0-3.1-.1-4.1c0-1.1-.2-1.8-.5-2.4-.3-.7-.6-1.3-1.2-1.8-.5-.5-1.1-.9-1.8-1.2-.6-.2-1.4-.4-2.4-.5h-4z" />
								<path
									d="M12 6.4c-3.1 0-5.6 2.5-5.6 5.6s2.5 5.6 5.6 5.6 5.6-2.5 5.6-5.6c0-3.1-2.5-5.6-5.6-5.6zm0 9.3c-2 0-3.7-1.6-3.7-3.7S10 8.3 12 8.3s3.7 1.6 3.7 3.7c0 2-1.7 3.7-3.7 3.7z" />
								<circle cx="17.9" cy="6.1" r="1.3" />
							</svg>
							<span class="sr-only">Instagram</span>
						</a>
					</li>
				</ul>
				<ul class="list-contact list-unstyled">
					<li>
						<a target="_blank" href="https://www.brainlab.com/contact-us/" aria-label="Contact us">
							<svg xmlns="http://www.w3.org/2000/svg" class="a-icon a-icon-envelope" viewBox="0 0 30.3 20">
								<path
									d="M0 0v20h30.3V0zm1.2 1.2h1l12.9 11L28 1.2h1v.7l-9.1 7.7 9.1 8.6v.5h-1.1l-8.8-8.3-3.9 3.3-3.9-3.3-8.8 8.3H1.3v-.5l9.1-8.6-9.1-7.7v-.7z" />
							</svg>
							<span class="global-footer-show-breakpoint-up">Contact us</span>
						</a>
					</li>
				</ul>
			</div>
			<div class="global-footer-navigation-container">
				<div class="footer__navigation-menu-container accordion">
					<div class="footer-navigation__item accordion__item">
						<input
							id="accordion-1"
							type="checkbox"
							aria-labelledby="accordion-heading-1"
							aria-controls="accordion-panel-1"
							class="accordion__toggle visuallyhidden" />
						<div class="accordion__header">
							<label for="accordion-1" class="accordion__title" data-parent="#accordion-1">
								<span class="accordion__title-text" id="accordion-heading-1">Company</span>
								<span class="accordion__trigger" tabindex="-1">
									<span class="visuallyhidden"></span> <span class="accordion__trigger-icon"></span>
								</span>
							</label>
						</div>
						<div
							class="accordion__collapse"
							id="accordion-panel-1"
							role="region"
							aria-labelledby="accordion-heading-1"
							data-parent="#accordion-1">
							<div class="accordion__body">
								<ul>
									<li>
										<a target="_blank" href="https://www.brainlab.com/about-brainlab/" aria-label="About us">
											About us
										</a>
									</li>
									<li>
										<a
											target="_blank"
											href="https://www.brainlab.com/about-brainlab/the-brainlab-companies/"
											aria-label="The Brainlab Companies">
											The Brainlab Companies
										</a>
									</li>
									<li>
										<a target="_blank" href="https://www.brainlab.com/news-and-events/" aria-label="News"> News </a>
									</li>
									<li>
										<a target="_blank" href="https://www.brainlab.com/newsroom/" aria-label="Newsroom"> Newsroom </a>
									</li>
									<li>
										<a target="_blank" href="https://www.brainlab.com/press-and-media/" aria-label="Press &amp; Media">
											Press &amp; Media
										</a>
									</li>
									<li>
										<a target="_blank" href="https://www.brainlab.com/about-brainlab/events/" aria-label="Events">
											Events
										</a>
									</li>
									<li><a target="_blank" href="https://www.brainlab.com/career/" aria-label="Careers"> Careers </a></li>
								</ul>
							</div>
						</div>
					</div>
					<div class="footer-navigation__item accordion__item">
						<input
							id="accordion-2"
							type="checkbox"
							aria-labelledby="accordion-heading-2"
							aria-controls="accordion-panel-2"
							class="accordion__toggle visuallyhidden" />
						<div class="accordion__header">
							<label for="accordion-2" class="accordion__title" data-parent="#accordion-2">
								<span class="accordion__title-text" id="accordion-heading-2">Products &amp; Services</span>
								<span class="accordion__trigger" tabindex="-2">
									<span class="visuallyhidden"></span> <span class="accordion__trigger-icon"></span>
								</span>
							</label>
						</div>
						<div
							class="accordion__collapse"
							id="accordion-panel-2"
							role="region"
							aria-labelledby="accordion-heading-2"
							data-parent="#accordion-2">
							<div class="accordion__body">
								<ul>
									<li>
										<a target="_blank" href="https://www.brainlab.com/surgery-products/" aria-label="Surgery">
											Surgery
										</a>
									</li>
									<li>
										<a target="_blank" href="https://www.brainlab.com/radiosurgery-products/" aria-label="Radiosurgery">
											Radiosurgery
										</a>
									</li>
									<li>
										<a target="_blank" href="https://www.brainlab.com/digital-o-r/" aria-label="Digital O.R.">
											Digital O.R.
										</a>
									</li>
									<li>
										<a target="_blank" href="https://userguides.brainlab.com/en/" aria-label="User Guides">
											User Guides
										</a>
									</li>
									<li>
										<a target="_blank" href="https://onlinecampus.brainlab.com/learn" aria-label="Online Campus">
											Online Campus
										</a>
									</li>
									<li>
										<a
											target="_blank"
											href="https://www.brainlab.com/brainlab-cloud-services/"
											aria-label="Brainlab Cloud Services">
											Brainlab Cloud Services
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="footer-navigation__item accordion__item">
						<input
							id="accordion-3"
							type="checkbox"
							aria-labelledby="accordion-heading-3"
							aria-controls="accordion-panel-3"
							class="accordion__toggle visuallyhidden" />
						<div class="accordion__header">
							<label for="accordion-3" class="accordion__title" data-parent="#accordion-3">
								<span class="accordion__title-text" id="accordion-heading-3">Brainlab Sphere</span>
								<span class="accordion__trigger" tabindex="-3">
									<span class="visuallyhidden"></span> <span class="accordion__trigger-icon"></span>
								</span>
							</label>
						</div>
						<div
							class="accordion__collapse"
							id="accordion-panel-3"
							role="region"
							aria-labelledby="accordion-heading-3"
							data-parent="#accordion-3">
							<div class="accordion__body">
								<ul>
									<li>
										<a target="_blank" href="https://www.brainlab.com" aria-label="Brainlab Company Website">
											Brainlab Company Website
										</a>
									</li>
									<li>
										<a target="_blank" href="https://www.novaliscircle.org" aria-label="Brainlab Novalis Circle">
											Brainlab Novalis Circle
										</a>
									</li>
									<li>
										<a
											target="_blank"
											href="https://www.brainlab-social-program.com/"
											aria-label="Brainlab Social Program">
											Brainlab Social Program
										</a>
									</li>
									<li>
										<a
											target="_blank"
											href="https://www.brainlab-culture-program.com/"
											aria-label="Brainlab Culture Program">
											Brainlab Culture Program
										</a>
									</li>
									<li>
										<a target="_blank" href="https://www.medical-langer.de/en_home.html" aria-label="Langer Medical">
											Langer Medical
										</a>
									</li>
									<li><a target="_blank" href="https://www.medphoton.at" aria-label="Medphoton"> Medphoton </a></li>
									<li><a target="_blank" href="https://mint-medical.com" aria-label="Mint Medical"> Mint Medical </a></li>
									<li><a target="_blank" href="https://www.snkeos.com" aria-label="Snke OS"> Snke OS </a></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="global-footer-meta">
				<a class="logo-brainlab-container" target="_blank" href="https://www.brainlab.com/" aria-label="Brainlab Home">
					<svg xmlns="http://www.w3.org/2000/svg" class="logo-brainlab" viewBox="0 0 233.57 31.93">
						<path
							d="M32.17 11.14c0 .2-.3.3-.6.4a20 20 0 0 1-4.3.1c.2-.6.4-1.3.7-2.2.1-.2 0-.4-.3-.5-.9-.2-3.2-.5-4.4.2a1 1 0 0 0-.5.7 7.37 7.37 0 0 0-.4 1.4c-4.9-.2-9.2.8-11.5 3.3a3.17 3.17 0 0 0-.8 2.5 3 3 0 0 0 2.8 2.3c.8.1 1.1-.2 1.1-.4-.3-.5 0-1.5 1.4-2.1 3.9-1.8 9.1-.9 12.7-.7a6 6 0 0 0 4.5-1c1-.8 1.6-2.5.6-3.5-.6-.7-.9-.7-1-.5m-3.7 8.7c-.1.5-1.4.4-2.4.4h-1.3c.3-.9.5-1.7.6-2.1.1-.2 0-.4-.3-.5-.9-.2-3.2-.5-4.4.2a1.48 1.48 0 0 0-.5.7 10.38 10.38 0 0 0-.3 1.2c-4.2-.2-7.7.7-10.8 5.1-2.3 3.4-3.3 7.1-7.7 5.8a7.93 7.93 0 0 1-.9-.4c-.2-.1-.4 0-.4.1s-.1.3.1.5a4.68 4.68 0 0 0 1.5.8c4 1 6.2-.6 8.8-4 .7-.9 2.3-3.6 8.1-3.6-.5 1.6-.9 3.2-1.2 4.3-.1.2 0 .4.3.5.9.2 3.2.5 4.4-.2a1.48 1.48 0 0 0 .5-.7c.3-.9.6-2.1 1-3.3a10.28 10.28 0 0 0 1.8.1 5.16 5.16 0 0 0 3.6-1.1c.8-.8 1.4-2.3.4-3.3-.5-.7-.9-.7-.9-.5m15.7-15.6a14.66 14.66 0 0 0-6.8-2.1 6.75 6.75 0 0 0-3.4.8 3.63 3.63 0 0 1-1.9.1 18.32 18.32 0 0 0-2.1-.2q.3-.9.6-2.1c0-.2 0-.4-.3-.5-.9-.2-3.2-.5-4.4.2a1 1 0 0 0-.5.7c-.1.5-.3.9-.4 1.3a14.23 14.23 0 0 0-7.7 2.1 4 4 0 0 0-1.9 2.9c-.1 1.5 1.3 2.6 2.8 2.8.8.1 1.1-.2 1-.4a1.4 1.4 0 0 1 .7-1.6c1.6-1.1 5.7-1.7 9.3-1.2 3.9.5 6.3 1.5 9 1.5a14.36 14.36 0 0 0 5.9-1.6 2.05 2.05 0 0 0 .8-1.4c.1-.4.1-.9-.7-1.3m-6.9.4c-1.7-.3-.8-1.4.1-1.4a3.18 3.18 0 0 1 2.5.9c.1.2-.6.8-2.6.5m32.8 12.2a4.77 4.77 0 0 0 3.1-4.8 5.1 5.1 0 0 0-1.7-4.2 8 8 0 0 0-5.3-1.5h-12.5v22.6H67c4.9 0 7.2-3.3 7.2-6.6a5.27 5.27 0 0 0-4.1-5.5m-3.9-1.2h-9v-6.2H66c2.7 0 3.7 1.1 3.7 3.1 0 1.8-1.1 3.1-3.5 3.1m-9 10.3v-7.2h9.2c3.3 0 4.3 1.8 4.3 3.5 0 1.9-.9 3.7-4.6 3.7zm40.6-3.1c-.1-2.5-1.2-4.4-3.1-4.8a5.58 5.58 0 0 0 3.6-5.5 6.19 6.19 0 0 0-1.4-4.1 6 6 0 0 0-4.8-1.9h-14v22.6h3.5v-9.5h8.6c2.7 0 4 1.1 4.2 5.1.2 2.7.1 3.6.7 4.3h3.8l-.2-.2c-.6-.8-.8-1.8-.9-6m-16.2-6.4v-6.9h9.3c2.6 0 3.8 1.4 3.8 3.5 0 1.5-.7 3.4-3.9 3.4zm30.5-10L101.87 29h3.8l2.9-6.5h10.8l2.9 6.5h4l-10.2-22.6zm6 13h-8.2l4-9.5zm12.1-13h3.5V29h-3.5V6.44zm27 0h3.5V29h-4l-14.3-17.7V29h-3.5V6.44h4l14.3 17.7zm12 19.5h13.6V29h-17.1V6.44h3.5zm26.5-19.5L185.47 29h3.8l2.9-6.5H203l2.9 6.5h4L199.7 6.4zm6 13h-8.2l4-9.5zm27.9-2.6a4.72 4.72 0 0 0 3.1-4.7 5.1 5.1 0 0 0-1.7-4.2 8 8 0 0 0-5.3-1.5h-12.6V29h13.3c4.9 0 7.2-3.3 7.2-6.6s-1.6-5-4-5.6m-4-1.2h-9V9.44h8.8c2.7 0 3.7 1.1 3.7 3.1 0 1.8-1.1 3-3.5 3.1m-9 10.2v-7.2h9.2c3.3 0 4.3 1.8 4.3 3.5 0 1.9-.9 3.7-4.6 3.7z" />
					</svg>
				</a>
				<ul class="list-unstyled">
					<li>
						<a target="_blank" href="https://www.brainlab.com/corporate-information/" aria-label="Corporate Information">
							Corporate Information
						</a>
					</li>
					<li>
						<a target="_blank" href="https://www.brainlab.com/privacy-policy/" aria-label="Privacy Policy"> Privacy Policy </a>
					</li>
					<li><a target="_blank" href="https://www.brainlab.com/compliance/" aria-label="Compliance"> Compliance </a></li>
				</ul>
				<div class="brainlab-copyright"><span>&copy; 2025 Brainlab SE</span></div>
			</div>
		</div>
	</v-footer>
</template>

<script>
export default {
	name: 'footer-novalis-circle',
}
</script>
<style>
#brainlab-global-footer {
	font-size: 14px;
	color: #5e5d61;
	background-color: #dfdedf;
}
#brainlab-global-footer .global-footer-content-container {
	width: 100%;
	padding: 2px 17px 17px;
}
@media (min-width: 1024px) {
	#brainlab-global-footer .global-footer-content-container {
		max-width: 1200px;
		margin-left: auto;
		margin-right: auto;
	}
}
#brainlab-global-footer .global-footer-social-contact {
	display: flex;
	justify-content: space-between;
	margin-bottom: 25px;
}
@media (min-width: 1024px) {
	#brainlab-global-footer .global-footer-social-contact {
		border-bottom: 1px solid #5e5d61;
		padding-top: 4px;
		padding-left: 13px;
		padding-right: 13px;
	}
}
#brainlab-global-footer .global-footer-content-container svg {
	fill: #5e5d61;
}
#brainlab-global-footer .global-footer-content-container svg:hover {
	fill: #ee2375;
}
#brainlab-global-footer a {
	color: #434549;
	text-decoration: none;
}
#brainlab-global-footer a:hover {
	text-decoration: underline;
}
#brainlab-global-footer .list-unstyled {
	padding-left: 0;
	list-style: none;
	margin-top: 14px;
	margin-bottom: 14px;
}
#brainlab-global-footer .list-inline-item {
	display: inline-block;
}
#brainlab-global-footer .list-inline-item:not(:last-child) {
	margin-right: 5px;
}
#brainlab-global-footer .list-social a {
	padding-right: 9px;
}
#brainlab-global-footer .list-contact a:hover svg {
	fill: #ee2375;
}
#brainlab-global-footer .list-contact .global-footer-show-breakpoint-up {
	display: none;
}
@media (min-width: 1024px) {
	#brainlab-global-footer .list-contact .global-footer-show-breakpoint-up {
		display: inline;
	}
}
#brainlab-global-footer .sr-only {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px; /* Fix for https://github.com/twbs/bootstrap/issues/25686 */
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
}
#brainlab-global-footer .a-icon--social-media-list {
	width: 20px;
	height: auto;
}
#brainlab-global-footer .a-icon-envelope {
	width: 19px;
	height: auto;
	margin-right: 4px;
}
#brainlab-global-footer .a-icon--arrow-up {
	fill: #fff;
	width: 13px;
	height: auto;
	margin-bottom: 10px;
}
#brainlab-global-footer .global-footer-meta {
	font-size: 13px;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}
@media (min-width: 1024px) {
	#brainlab-global-footer .global-footer-meta {
		padding-left: 13px;
		padding-right: 13px;
		flex-wrap: nowrap;
		align-items: center;
	}
}
#brainlab-global-footer .global-footer-meta .list-unstyled {
	font-size: 14px;
	order: 1;
	flex-basis: 100%;
	margin-bottom: 53px;
}
@media (min-width: 1024px) {
	#brainlab-global-footer .global-footer-meta .list-unstyled {
		flex-basis: auto;
		margin-bottom: 0;
		margin-top: 0;
		text-align: center;
	}
	#brainlab-global-footer .global-footer-meta .list-unstyled li {
		display: inline-block;
	}
}
#brainlab-global-footer .global-footer-meta .list-unstyled a {
	display: inline-block;
	padding-top: 10px;
	padding-bottom: 10px;
	font-size: 13px;
}
@media (min-width: 1024px) {
	#brainlab-global-footer .global-footer-meta .list-unstyled a {
		padding-left: 15px;
		padding-right: 15px;
		position: relative;
	}
	#brainlab-global-footer .global-footer-meta .list-unstyled a:after {
		content: '';
		border-right: 1px solid #434549;
		display: block;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		width: 1px;
		height: 12px;
		right: 0;
	}
	#brainlab-global-footer .global-footer-meta .list-unstyled li:last-child a:after {
		display: none;
	}
}
#brainlab-global-footer .global-footer-meta .logo-brainlab-container {
	order: 2;
}
@media (min-width: 1024px) {
	#brainlab-global-footer .global-footer-meta .logo-brainlab-container {
		order: 1;
	}
}
#brainlab-global-footer .logo-brainlab {
	width: 103px;
}
#brainlab-global-footer .global-footer-meta .brainlab-copyright {
	color: #434549;
	order: 3;
	white-space: nowrap;
}
#brainlab-global-footer .global-footer-navigation-container {
	margin-bottom: 32px;
}
@media (min-width: 1024px) {
	#brainlab-global-footer .global-footer-navigation-container {
		padding-left: 13px;
		padding-right: 13px;
	}
}
#brainlab-global-footer .global-footer-navigation-container a {
	padding-top: 4px;
	padding-bottom: 3px;
	display: inline-block;
	font-weight: 400;
} /* ACCORDION CSS BASED */
#brainlab-global-footer .visuallyhidden {
	position: absolute;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	width: 1px;
	height: 1px;
	padding: 0;
	white-space: nowrap;
	border: 0;
	clip-path: inset(50%);
}
@media (min-width: 1024px) {
	#brainlab-global-footer .footer__navigation-menu-container {
		display: flex;
		justify-content: space-between;
	}
}
#brainlab-global-footer .accordion .accordion__item {
	margin-bottom: 18px;
}
#brainlab-global-footer .accordion .accordion__header {
	padding-top: 0.2em;
	padding-bottom: 0.2em;
}
#brainlab-global-footer .accordion .accordion__body,
#brainlab-global-footer .accordion .accordion__header {
	padding-left: 4px;
	padding-right: 4px;
}
#brainlab-global-footer .accordion .accordion__title {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-wrap: nowrap;
	margin: 0;
	transition: color 0.3s ease-in-out;
	border-bottom: 1px solid #5e5d61;
	font-size: 22px;
	cursor: pointer;
}
@media (min-width: 1024px) {
	#brainlab-global-footer .accordion .accordion__title {
		cursor: default;
		pointer-events: none;
		border-bottom-color: transparent;
	}
}
#brainlab-global-footer .accordion .accordion__title .accordion__title-text {
	color: #434549;
	margin-bottom: 0;
	border-bottom: 1px solid transparent;
	transition: border-color 0.3s ease-in-out;
}
#brainlab-global-footer .accordion .accordion__trigger,
#brainlab-global-footer .accordion .accordion__trigger .accordion__trigger-icon {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
}
#brainlab-global-footer .accordion .accordion__trigger {
	width: 47px;
	height: 47px;
	padding: 0;
	margin: 0 0 0 auto;
	pointer-events: none;
	flex-shrink: 0;
}
@media (min-width: 1024px) {
	#brainlab-global-footer .accordion .accordion__trigger {
		visibility: hidden;
	}
}
#brainlab-global-footer .accordion .accordion__trigger .accordion__trigger-icon {
	min-width: 15px;
	transition: transform 0.2s ease-in-out;
}
#brainlab-global-footer .footer__navigation-menu-container .accordion__trigger-icon:after,
#brainlab-global-footer .footer__navigation-menu-container .accordion__trigger-icon:before {
	background-color: #fff;
}
#brainlab-global-footer .accordion .accordion__trigger .accordion__trigger-icon:after,
#brainlab-global-footer .accordion .accordion__trigger .accordion__trigger-icon:before {
	content: \"\";
	display: block;
	position: absolute;
	top: 50%;
	width: 100%;
	height: 3px;
	background-color: #5e5d61;
	transition: transform 0.2s ease-in-out, background-color 0.3s ease-in-out;
}
#brainlab-global-footer .accordion .accordion__trigger .accordion__trigger-icon:before {
	left: 0;
	transform: rotate(90deg);
}
#brainlab-global-footer .accordion .accordion__toggle:checked + .accordion__header .accordion__trigger-icon:before {
	transform: rotate(-0deg);
}
#brainlab-global-footer .accordion .accordion__trigger .accordion__trigger-icon:after {
	right: 0;
	transform: rotate(-0deg);
}
#brainlab-global-footer .accordion .accordion__toggle:checked + .accordion__header .accordion__trigger-icon:after {
	transform: rotate(0deg);
}
#brainlab-global-footer .accordion .accordion__collapse {
	max-height: 0;
	visibility: hidden;
	overflow: hidden;
	transition: visibility 0.1ms linear 0.8s, max-height 0.8s ease-in-out;
}
@media (min-width: 1024px) {
	#brainlab-global-footer .accordion .accordion__collapse {
		visibility: visible;
		max-height: none;
	}
}
#brainlab-global-footer .accordion .accordion__toggle:checked ~ .accordion__collapse {
	max-height: 600px;
	visibility: visible;
	transition: max-height 1s ease-in-out;
}
#brainlab-global-footer .accordion .accordion__body {
	padding-top: 0.2em;
	padding-bottom: 0.5em;
}
#brainlab-global-footer .footer__navigation-menu-container ul {
	list-style: none;
	padding-left: 0;
	margin: 0;
}
#brainlab-global-footer .footer__navigation-menu-container li {
	padding-top: 0.5em;
	padding-bottom: 0.5em;
}
</style>
